import React, { useContext, useState } from "react";
import contactImg1 from "../../assets/images/shapes/contact-1-shape-2.png";
import contactImg2 from "../../assets/images/new/4.jpg";
import contactImg3 from "../../assets/images/new/2.jpg";
import contactImg4 from "../../assets/images/new/conatus us.png";
import contactImg5 from "../../assets/images/shapes/about-1-shape-2.png";
import contactImg6 from "../../assets/images/shapes/about-1-shape-3.png";
import { ERROR_MESSAGES } from "../../Components/GlobalErrorMessage";
import GoogleMap from "../../Components/GoogleMapModal";
import ContactUsImg from "../../assets/images/new/ContactUsImg.png";
import ContactUS from "../../assets/images/new/aboutUsImage.png";
import batuk from "../../assets/images/new/fav-removebg-preview.png";
import { Helmet } from "react-helmet-async";
import { AddContactUs, ContactUSApi } from "../../ApiServices/NewsLettter/NewsLetterApi";
import SuccessModal from "../../Components/SuccessModal";
import { useNavigate } from "react-router-dom";
import DownloadApp from "../../Components/DownLoadApp/DownloadApp";
import { t } from "i18next";
import { LoaderContext } from "../../AuthContext/AuthContext";

const ContactPage = () => {
  const userKeyID = localStorage.getItem("userKeyID") || "";
  const { setLoader, selectedLanguageID } = useContext(LoaderContext);
  const [Action, setAction] = useState([]);
  const [showSuccessPopUp, setShowSuccessPopUp] = useState(null);
  const navigate = useNavigate();
  const [contactData, setContactData] = useState({
    FirstName: null,
    LasteName: null,
    Email: null,
    PhoneNo: null,
    Message: null,
  });
  const [contactUsMsg, setContactUsMsg] = useState(false);
  const [error, setError] = useState(false);
  const [verified, setVerified] = useState(null);

  function onCaptchaChange(value) {

    setVerified(true);
  }

  const handleContactFormSubmit = () => {
    let isValid = false;
    if (
      contactData.FirstName === "" ||
      contactData.FirstName === undefined ||
      contactData.FirstName === null ||
      contactData.LasteName === "" ||
      contactData.LasteName === "" ||
      contactData.LasteName === "" ||
      contactData.PhoneNo === "" ||
      contactData.PhoneNo === undefined ||
      contactData.PhoneNo === null ||
      contactData?.PhoneNo?.length !== 10 ||
      contactData.Message === "" ||
      contactData.Message === undefined ||
      contactData.Message === null ||
      contactData.Email === "" ||
      contactData.Email === undefined ||
      contactData.Email === null
    ) {
      isValid = true;
      setError(true);
    } else if (
      contactData.Email !== null &&
      !validateEmail(contactData.Email)
    ) {
      isValid = true;
      setError(true);
    }

    const api_params = {

      firstName: contactData.FirstName,
      lastName: contactData.LasteName,
      email: contactData.Email,
      phoneNo: contactData.PhoneNo,
      message: contactData.Message,
    };

    if (!isValid) {
      ContactUsAPI(api_params);
    }
  };


  const ContactUsAPI = async (api_params) => {
    setLoader(true)
    try {
      const response = await AddContactUs(api_params);

      if (response?.statusCode === 200) {
        setLoader(false)
        navigate("/thank-you", {
          state: { moduleName: "ContactUs" },
        });
      } else {
        setLoader(false)
      }
    } catch (error) {
      setLoader(false)
      console.log(error);
    }
  };

  const closeAll = () => {
    //  ;
    setShowSuccessPopUp(false);
    setInitialData();
  };

  const setInitialData = () => {
    setError(false);
    setContactData((prev) => ({
      ...prev,
      FirstName: "",
      LasteName: "",
      Email: "",
      PhoneNo: "",
      Message: "",
    }));
  };


  const validateEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };
  return (
    <>
      <section className="page-header">
        <div className="page-header__bg"></div>
        <div className="container d-flex justify-content-center align-items-center">
          <h2 className="page-header__title bw-split-in-left">{t("Contact Us")}</h2>
        </div>
      </section>

      <Helmet>
        <title>Contact Us for Spiritual Services - Myomnamo</title>
        <meta
          name="description"
          content="Have questions or need assistance? Reach out to us for pandit booking, puja arrangements, and spiritual guidance. We’re here to help!"
        />
        <link rel="canonical" href="https://www.myomnamo.com/contact-us" />

        {/* Open Graph Tags */}
        <meta
          property="og:title"
          content="Contact Us for Spiritual Services - Myomnamo"
        />
        <meta
          property="og:description"
          content="Have questions or need assistance? Reach out to us for pandit booking, puja arrangements, and spiritual guidance. We’re here to help!"
        />
        <meta
          property="og:image"
          content="https://www.myomnamo.com/assets/images/new/logo.png"
        />
        <meta property="og:url" content="https://www.myomnamo.com/contact-us" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Myomnamo" />
        <meta property="og:locale" content="en_IN" />

        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Contact Us for Spiritual Services - Myomnamo"
        />
        <meta
          name="twitter:description"
          content="Have questions or need assistance? Reach out to us for pandit booking, puja arrangements, and spiritual guidance. We’re here to help!"
        />
        <meta
          name="twitter:image"
          content="https://www.myomnamo.com/assets/images/new/logo.png"
        />
      </Helmet>

      <section
        className="contact-one contact-one--page"

      >
        <div className="container">
          <div
            className="contact-one__shape"
            style={{
              backgroundImage: `url("${contactImg1}")`,
            }}
          ></div>
          <div className="" style={{ display: "flex", flexDirection: "column" }}>
            <div className="row">
              <div className="col-xl-6">
                <div
                  className="about-one__image wow fadeInLeft"
                  data-wow-delay="100ms"
                  style={{ padding: "0px" }}
                >
                  <div className="about-one__image__one">
                    <img
                      src={ContactUS}
                      style={{
                        height: "540px",

                        objectFit: "contain",
                      }}
                      alt="contact"
                    />
                  </div>

                  <div className="about-one__image__shape-one">
                    {/* <img src={contactImg4} alt="shape" /> */}
                  </div>
                  <div className="about-one__image__shape-two">
                    {/* <img src={contactImg5} alt="shape" /> */}
                  </div>
                  <div className="about-one__image__shape-three">
                    {/* <img src={contactImg6} alt="shape" /> */}
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="card-body" style={{ marginLeft: "12px" }}>
                  <h6 className="sec-title__tagline bw-split-in-right">
                    <img className=" tagline-img" src={batuk} alt="" />
                    {t("Get in Touch with Us")}
                  </h6>
                  <h3 className="sec-title__title bw-split-in-left">
                    {t("Let’s Talk! Contact Us Today")}
                  </h3>
                  <p className="contact-one__text">
                    {t("We’re here to answer any questions you have and help you get started on your spiritual journey. Reach out and let’s connect!")}
                  </p>
                  <div className="card p-3">
                    <div className="row gy-3">
                      <div className="col-md-6">
                        <label className="form-label fw-light">
                          {t("First Name")} <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="custom-form-control rounded-3"
                          placeholder={t("Enter first name")}
                          value={contactData.FirstName}
                          onChange={(e) => {
                            let inputValue = e.target.value;

                            // Remove spaces completely
                            inputValue = inputValue.replace(/\s/g, "");

                            // Capitalize the first letter
                            if (inputValue?.length > 0) {
                              inputValue =
                                inputValue.charAt(0).toUpperCase() +
                                inputValue.slice(1);
                            }

                            setContactData((prev) => ({
                              ...prev,
                              FirstName: inputValue,
                            }));
                          }}
                        />
                        {(error && contactData.FirstName === null) ||
                          contactData.FirstName === undefined ||
                          contactData.FirstName === "" ? (
                          <span className="error-msg">{t(ERROR_MESSAGES)}</span>
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="col-md-6">
                        <label className="form-label fw-light">
                          {t("Last Name")} <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="custom-form-control rounded-3"
                          placeholder={t("Enter last name")}
                          value={contactData.LasteName}
                          onChange={(e) => {
                            let inputValue = e.target.value;

                            // Remove spaces completely
                            inputValue = inputValue.replace(/\s/g, "");

                            // Capitalize the first letter
                            if (inputValue?.length > 0) {
                              inputValue =
                                inputValue.charAt(0).toUpperCase() +
                                inputValue.slice(1);
                            }

                            setContactData((prev) => ({
                              ...prev,
                              LasteName: inputValue,
                            }));
                          }}
                        />
                        {(error && contactData.LasteName === null) ||
                          contactData.LasteName === undefined ||
                          contactData.LasteName === "" ? (
                          <span className="error-msg">{t(ERROR_MESSAGES)}</span>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>

                    <div className="row gy-3">
                      <div className="col-md-6">
                        <label className="form-label fw-light">
                          {t("Mobile Number")} <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="custom-form-control rounded-3"
                          maxLength={10}
                          placeholder={t("Enter mobile number")}
                          value={contactData.PhoneNo || ""}
                          onChange={(e) => {
                            const numericValue = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
                            setContactData((prev) => ({
                              ...prev,
                              PhoneNo: numericValue,
                            }));
                          }}
                        />
                        {error &&
                          (contactData.PhoneNo === "" ||
                            contactData?.PhoneNo === null ||
                            contactData?.PhoneNo === undefined) ? (
                          <span style={{ color: "red", fontSize: "15px" }}>
                            {t(ERROR_MESSAGES)}
                          </span>
                        ) : error &&
                          contactData.PhoneNo?.length > 0 &&
                          contactData.PhoneNo?.length !== 10 ? (
                          <span style={{ color: "red", fontSize: "15px" }}>
                            {t("Invalid Mobile Number")}
                          </span>
                        ) : null}
                      </div>
                      <div className="col-md-6">
                        <label className="form-label fw-light">
                          {t("Email")} <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="custom-form-control rounded-3"
                          placeholder={t("Enter your email")}
                          value={contactData.Email}
                          onChange={(e) => {
                            setError(false);
                            let InputValue = e.target.value;

                            if (InputValue.startsWith(" ")) {
                              InputValue = InputValue.trimStart(); // Remove leading space
                            }

                            setContactData((prev) => ({
                              ...prev,
                              Email: InputValue,
                            }));
                          }}
                        />
                        {error &&
                          (contactData.Email === null ||
                            contactData.Email === undefined ||
                            contactData.Email === "") ? (
                          <span
                            style={{
                              color: "red",
                              fontSize: "15px",
                            }}
                          >
                            {t(ERROR_MESSAGES)}
                          </span>
                        ) : contactData.Email !== null &&
                          contactData.Email !== "" &&
                          !validateEmail(contactData.Email) ? (
                          <span style={{ color: "red", fontSize: "15px" }}>
                            {t("Please enter a valid email")}
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>

                    <div className="row gy-3" style={{ justifyContent: "left" }}>
                      <div className="col-md-12">
                        <label className="form-label fw-light">
                          {t("Your Message")} <span className="text-danger">*</span>
                        </label>
                        <textarea
                          type="text"
                          className="custom-form-control"
                          rows="5"
                          style={{ height: "73px" }}
                          onChange={(e) => {
                            let inputValue = e.target.value;

                            // Prevent first character from being a space
                            if (inputValue.startsWith(" ")) {
                              inputValue = inputValue.trimStart();
                            }

                            // Replace multiple spaces with a single space
                            inputValue = inputValue.replace(/\s{2,}/g, " ");

                            // Allow only letters, numbers, and spaces
                            inputValue = inputValue.replace(/[^a-zA-Z0-9\s]/g, "");

                            setContactData((prev) => ({
                              ...prev,
                              Message: inputValue,
                            }));
                          }}
                          value={contactData.Message}
                          placeholder={t("Your Message")}
                          maxLength={200}
                        ></textarea>
                        {error &&
                          (contactData.Message === null ||
                            contactData.Message === undefined ||
                            contactData.Message === "") ? (
                          <span
                            style={{
                              color: "red",
                              fontSize: "15px",
                            }}
                          >
                            {t(ERROR_MESSAGES)}
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>

                    {/* Submit Button */}
                    <div className="d-flex justify-content-left mt-4">
                      <button
                        className="Normal-app-btn"
                        style={{ fontSize: "16px" }}
                        onClick={() => handleContactFormSubmit()}
                      >
                        {t("Submit")}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <SuccessModal
            Action={"Contact"}
            show={showSuccessPopUp}
            onHide={() => setShowSuccessPopUp(false)}
            setContactUsMsg={setContactUsMsg}
            contactUsMsg={contactUsMsg}
            onConfirm={closeAll}
          // Action={Action}
          />
        </div>
      </section>
      <section>
        <div className="row mt-2">
          <div
            className="col-12 w-100"
            style={{ padding: "0px", marginTop: "5px" }}
          >
            <GoogleMap className="" />
          </div>
        </div>
        <DownloadApp languageID={selectedLanguageID == 3 ? 1 : null} />
      </section>
    </>
  );
};

export default ContactPage;
